import { useState, useEffect, Fragment } from "react";
import { fieldType } from "../../../../types/form";
import { Controller, useFieldArray } from "react-hook-form";
import UploadFiles from "../uploadFiles";
import Input from "../input";
import Select from "../select";
import DateField from '../date';
import Button from "../../../Button";
import Text from "../text";
import PeoplePicker from "../peoplePicker";
import Autocomplete from "../autocomplete";
import { useAppSelector } from "src/hooks/redux";
import { selectDeleteStatus } from "src/modules/spItems/selectors";
import Loading from "src/components/Loading";
import { equipmentsByDocumentListName } from "src/api/config";
import { TooltipItem } from "src/utils/Tooltip";
import { InfoIcon } from "src/components/ui-icons/myTasks/info";

type Props = {
    dataField: fieldType;
    control: any;
    useWatch: any;
    errors?: any;
    watch?: any;
    type: string;
    setIdRemoveElem: any;
    questionsInc?: string;
    updateRepeaterField?: boolean;
    setUpdateRepeaterField?: any
    isMobileDocumentCard?: boolean
}

function Repeater(props: Props) {

    const { dataField, control, errors, watch, type, setIdRemoveElem, useWatch, questionsInc, setUpdateRepeaterField, isMobileDocumentCard } = props;

    const { fields, append, remove } = useFieldArray({
        control,
        name: dataField.key
    });

    // Или используем useWatch для оптимизации
    const watchedRepeater = useWatch({
        control,
        name: dataField.key
    });

    const controlledFields = fields.map((field, index) => {
        if (watchedRepeater && watchedRepeater.length > 0 && watchedRepeater[index]) {
            return {
                ...field,
                ...watchedRepeater[index]
            };
        } else {
            return { ...field }
        }
    });

    const [newField, setNewField] = useState({});
    const [idxRemoveEquipment, setIdxRemoveEquipment] = useState<any>(null);
    const [idRemoveEquipment, setIdRemoveEquipment] = useState<any>(null);
    const statusRemoveEquipment = useAppSelector((state: any) => selectDeleteStatus(state, equipmentsByDocumentListName));

    const removeEquipments = (params: any) => {
        const { idxEquipment, idEquipment } = params;
        if (!idEquipment) {
            remove(idxEquipment);
        } else {
            setIdxRemoveEquipment(idxEquipment);
            setIdRemoveEquipment(idEquipment);
            setIdRemoveElem({ listName: equipmentsByDocumentListName, ID: idEquipment, updateReducer: true });
        }
    }

    useEffect(() => {
        if (statusRemoveEquipment === 'SUCCESS') {
            remove(idxRemoveEquipment);
        }
    }, [statusRemoveEquipment, type]);

    useEffect(() => {
        if (dataField.key === 'MIncEq' && (!watchedRepeater || (watchedRepeater && watchedRepeater.length === 0))) {
            append(newField);
        }
    }, [dataField]);

    useEffect(() => {
        if (questionsInc && watchedRepeater && watchedRepeater.length > 0 && questionsInc.indexOf(JSON.stringify(watchedRepeater)) === -1) {
            setUpdateRepeaterField(true);
        } else {
            setUpdateRepeaterField(false);
        }
    }, [watchedRepeater, questionsInc]);

    return (
        <div className={`flex flex-row flex-wrap ${dataField.width}`}>
            {controlledFields.length > 0 &&
                <label className="w-full flex flex-row justify-between text-sm font-medium leading-6 text-gray-900 mb-2">
                    <span className="flex flex-row items-center">{dataField.title} {dataField.noticeIcon && <TooltipItem wrapperClassName="flex w-[758px]" position="top-right" tooltipsComponent={dataField.notice} tooltipsText="">
                        <>&nbsp;&nbsp;<InfoIcon /></>
                    </TooltipItem>}</span>
                    {dataField.require && (
                        <div className="flex flex-row justify-between">
                            {Object.keys(errors).length > 0 && errors[dataField.key] && (
                                <span className="text-[#BA0C2F]">Заполните поле&nbsp;</span>
                            )}
                            <span className="text-[#BA0C2F]">*</span>
                        </div>
                    )}
                </label>
            }
            {controlledFields.map((field, index) => {
                return (
                    <div key={field.id} className="flex flex-row relative">
                        <section className=" mb-5 p-5 rounded-lg bg-[#F3F4F6] flex flex-row flex-wrap justify-between">
                            {statusRemoveEquipment === 'LOADING' && controlledFields[index]['ID'] === idRemoveEquipment && <Loading /> || (
                                <>
                                    {dataField.fields && dataField.fields.map((repeaterField: fieldType, idx: number) => (
                                        <Fragment key={`${dataField.key}.${idx}.${repeaterField.key}`}>
                                            {repeaterField.type === 'file' && (
                                                <Controller
                                                    name={`${dataField.key}.${index}.${repeaterField.key}`}
                                                    control={control}
                                                    rules={{ required: repeaterField.require }}
                                                    render={({ field }) => <UploadFiles setIdRemoveElem={setIdRemoveElem} value={field.value} type={type} dataField={repeaterField} onChange={(value: any) => field.onChange(value)} />}
                                                />
                                            )}
                                            {repeaterField.type === 'input' && (
                                                <Controller
                                                    name={`${dataField.key}.${index}.${repeaterField.key}`}
                                                    control={control}
                                                    rules={{ required: repeaterField.require }}
                                                    render={({ field }) => <Input errors={errors} dataField={repeaterField} value={field.value} onChange={(value: any) => field.onChange(value)} />}
                                                />
                                            )}
                                            {repeaterField.type === 'select' && (
                                                <Controller
                                                    name={`${dataField.key}.${index}.${repeaterField.key}`}
                                                    control={control}
                                                    rules={{ required: repeaterField.require }}
                                                    render={({ field }) => <Select dataField={repeaterField} value={field.value} onChange={(value: any) => field.onChange(value)} />}
                                                />
                                            )}
                                            {repeaterField.type === 'autocomplete' && (
                                                <Controller
                                                    name={`${dataField.key}.${index}.${repeaterField.key}`}
                                                    control={control}
                                                    rules={{ required: repeaterField.require }}
                                                    render={({ field }) => <Autocomplete errors={errors} dataField={repeaterField} value={field.value} onChange={(value: any) => field.onChange(value)} />}
                                                />
                                            )}
                                            {repeaterField.type === 'peoplePicker' && (
                                                <Controller
                                                    name={`${dataField.key}.${index}.${repeaterField.key}`}
                                                    control={control}
                                                    rules={{ required: repeaterField.require }}
                                                    render={({ field }) => <PeoplePicker type={type} dataField={repeaterField} value={field.value} onChange={(value: any) => field.onChange(value)} />}
                                                />
                                            )}
                                            {repeaterField.type === 'date' && (
                                                <Controller
                                                    name={`${dataField.key}.${index}.${repeaterField.key}`}
                                                    control={control}
                                                    rules={{ required: repeaterField.require }}
                                                    render={({ field }) => <DateField type={type} dataField={repeaterField} value={field.value} onChange={(value: any) => field.onChange(value)} />}
                                                />
                                            )}
                                            {repeaterField.type === 'text' && (
                                                <Text controlledFields={controlledFields} type={type} idx={index} dataField={repeaterField} />
                                            )}
                                            {repeaterField.type === 'repeater' && (
                                                <Repeater setIdRemoveElem={setIdRemoveElem} type={type} watch={watch} dataField={repeaterField} control={control} useWatch={useWatch} />
                                            )}
                                        </Fragment>
                                    ))}
                                </>
                            )}
                        </section>
                        {statusRemoveEquipment === 'LOADING' && controlledFields[index]['ID'] === idRemoveEquipment && <></> ||
                            <>
                                {dataField.key !== 'MIncEq' && !dataField.disabled &&
                                    <Button
                                        classBg="btn-white self-start ml-[10px]"
                                        text=""
                                        icon={true}
                                        shadow={true}
                                        typeIcon='remove'
                                        customFunction={removeEquipments}
                                        paramsCustomFunction={{ idxEquipment: index, idEquipment: controlledFields[index]['ID'] || null }}
                                    />
                                }
                            </>
                        }
                    </div>
                );
            })}

            {dataField.key !== 'MIncEq' && !dataField.disabled && !isMobileDocumentCard &&
                <Button
                    classBg="btn-white w-full justify-center mb-5"
                    text="Добавить оборудование"
                    icon={true}
                    shadow={true}
                    typeIcon="add"
                    customFunction={append}
                    paramsCustomFunction={newField}
                />
            }
        </div>
    );
}

export default Repeater;





